/* Reef Lagoon — Stockists locator.
 * Progressive enhancement for sections/stockists-page.liquid.
 *  - The server-rendered grouped list is the source of truth (works with zero JS).
 *  - Search + state + store-type filters act on the list (case-insensitive, combined AND).
 *  - The Leaflet map is lazy-initialised AFTER paint; if Leaflet fails to load the list and
 *    filters still work (the map block just stays empty).
 *  - Map <-> list sync: "Show on map" flies + opens popup; clicking a marker highlights the card.
 * Self-hosted Leaflet 1.9.4 + markercluster 1.5.3. CARTO Voyager tiles (no key). */
(function () {
  'use strict';

  var root = document.querySelector('[data-rsl]');
  if (!root) return;

  var dataEl = document.getElementById('rsl-data');
  var STORES = [];
  try { STORES = JSON.parse(dataEl.textContent); } catch (e) { STORES = []; }

  var cards = [].slice.call(root.querySelectorAll('[data-rsl-card]'));
  var groups = [].slice.call(root.querySelectorAll('[data-rsl-group]'));
  var searchEl = root.querySelector('[data-rsl-search]');
  var stateEl = root.querySelector('[data-rsl-state]');
  var typeEl = root.querySelector('[data-rsl-type]');
  var countEl = root.querySelector('[data-rsl-count]');
  var emptyEl = root.querySelector('[data-rsl-empty]');
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- list filtering (independent of the map) ---------------- */
  var visibleIds = {};

  function currentFilter() {
    return {
      q: ((searchEl && searchEl.value) || '').trim().toLowerCase(),
      st: (stateEl && stateEl.value) || '',
      ty: (typeEl && typeEl.value) || ''
    };
  }

  function matches(card, f) {
    if (f.st && card.dataset.state !== f.st) return false;
    if (f.ty && (card.dataset.type || '').toLowerCase() !== f.ty) return false;
    if (f.q) {
      var hay = card.dataset.name + ' ' + card.dataset.suburb + ' ' + (card.dataset.postcode || '');
      if (hay.indexOf(f.q) === -1) return false;
    }
    return true;
  }

  function applyFilter() {
    var f = currentFilter();
    var n = 0;
    visibleIds = {};
    cards.forEach(function (c) {
      var ok = matches(c, f);
      c.hidden = !ok;
      if (ok) { n++; visibleIds[parseInt(c.dataset.id, 10)] = true; }
    });
    groups.forEach(function (g) {
      g.hidden = !g.querySelector('[data-rsl-card]:not([hidden])');
    });
    if (countEl) countEl.textContent = n;
    if (emptyEl) emptyEl.hidden = n !== 0;
    updateMapMarkers();
  }

  if (searchEl) searchEl.addEventListener('input', applyFilter);
  if (stateEl) stateEl.addEventListener('change', applyFilter);
  if (typeEl) typeEl.addEventListener('change', applyFilter);

  /* ---------------- map (lazy, optional) ---------------- */
  var map = null, clusterGroup = null, markersById = {};

  function esc(s) { s = s == null ? '' : String(s); return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function escAttr(s) { return esc(s).replace(/"/g, '&quot;'); }

  function popupHtml(s) {
    var loc = esc(s.suburb) + (s.suburb && s.state ? ', ' : '') + esc(s.state);
    var dir = s.maps
      ? '<a href="' + escAttr(s.maps) + '" target="_blank" rel="noopener" aria-label="Get directions to ' + escAttr(s.name) + '">Get Directions</a>'
      : '';
    return '<div class="rsl-pop"><strong>' + esc(s.name) + '</strong><span>' + loc + '</span>' + dir + '</div>';
  }

  function fitAll() {
    if (!map) return;
    var pts = [];
    STORES.forEach(function (s) { if (visibleIds[s.id] && s.lat != null && s.lng != null) pts.push([s.lat, s.lng]); });
    if (!pts.length) STORES.forEach(function (s) { if (s.lat != null && s.lng != null) pts.push([s.lat, s.lng]); });
    if (pts.length) map.fitBounds(pts, { padding: [34, 34], maxZoom: 7 });
  }

  function updateMapMarkers() {
    if (!map || !clusterGroup) return;
    clusterGroup.clearLayers();
    STORES.forEach(function (s) {
      if (visibleIds[s.id] && markersById[s.id]) clusterGroup.addLayer(markersById[s.id]);
    });
    fitAll();
  }

  function highlightCard(id, scroll) {
    cards.forEach(function (c) { c.classList.toggle('is-active', parseInt(c.dataset.id, 10) === id); });
    var card = document.getElementById('store-' + id);
    if (card && scroll) card.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
  }

  function flyToStore(id) {
    var s = STORES[id];
    if (!map || !s || s.lat == null) return;
    var m = markersById[id];
    var done = function () { if (m) m.openPopup(); };
    if (m && clusterGroup.zoomToShowLayer) { clusterGroup.zoomToShowLayer(m, done); }
    map.flyTo([s.lat, s.lng], Math.max(map.getZoom(), 11), { animate: !REDUCE });
    highlightCard(id, true);
  }

  // "Show on map" buttons (event-delegated; cards may be re-filtered).
  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rsl-show]');
    if (!btn) return;
    var id = parseInt(btn.getAttribute('data-rsl-show'), 10);
    flyToStore(id);
    var mapEl = document.getElementById('rsl-map');
    if (mapEl) mapEl.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'nearest' });
  });

  function initMap() {
    if (typeof L === 'undefined') return; // Leaflet failed to load — list + filters still work.
    var mapEl = document.getElementById('rsl-map');
    if (!mapEl || map) return;

    map = L.map(mapEl, { scrollWheelZoom: false, attributionControl: true });
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      maxZoom: 19,
      subdomains: 'abcd',
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
    }).addTo(map);

    // Scroll-wheel zoom only once the map has focus/click (no scroll hijack).
    map.on('focus', function () { map.scrollWheelZoom.enable(); });
    map.on('blur', function () { map.scrollWheelZoom.disable(); });

    // Faint Great Barrier Reef line off the QLD coast (low-key brand nod).
    L.polyline(
      [[-10.7, 143.7], [-14.7, 145.5], [-16.9, 146.3], [-19.0, 147.5], [-21.0, 150.2], [-23.4, 151.9], [-24.5, 153.1]],
      { color: '#ECD43C', weight: 5, opacity: 0.4, lineCap: 'round', interactive: false }
    ).addTo(map);

    clusterGroup = L.markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 45,
      iconCreateFunction: function (cluster) {
        return L.divIcon({ className: 'rsl-cluster', html: '<span>' + cluster.getChildCount() + '</span>', iconSize: [38, 38] });
      }
    });

    STORES.forEach(function (s) {
      if (s.lat == null || s.lng == null) return;
      var icon = L.divIcon({ className: 'rsl-pin', html: '<span class="rsl-pin__dot"></span>', iconSize: [20, 20], iconAnchor: [10, 10] });
      var m = L.marker([s.lat, s.lng], { icon: icon, keyboard: true, title: s.name, alt: s.name + ', ' + (s.suburb || '') + ' ' + (s.state || '') });
      m.bindPopup(popupHtml(s));
      m.on('click', function () { highlightCard(s.id, true); });
      m.on('popupopen', function () { highlightCard(s.id, false); });
      markersById[s.id] = m;
    });

    map.addLayer(clusterGroup);
    updateMapMarkers();
  }

  /* ---------------- boot ---------------- */
  applyFilter(); // set initial count + visibleIds before the map builds

  function start() {
    if ('requestIdleCallback' in window) requestIdleCallback(initMap, { timeout: 1500 });
    else setTimeout(initMap, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
